/* unplugin-vue-components disabled */import { render } from "./prompts.vue?vue&type=template&id=2e5c4c25"
import script from "./prompts.vue?vue&type=script&lang=js"
export * from "./prompts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat-input/prompts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e5c4c25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e5c4c25', __exports__)) {
    api.reload('2e5c4c25', __exports__)
  }
  
  module.hot.accept("./prompts.vue?vue&type=template&id=2e5c4c25", () => {
    api.rerender('2e5c4c25', render)
  })

}


export default __exports__